export const formatPhone = (phone) => {
  const str = String(phone || '');
  if (str.length !== 10) return 'N/A';
  return `${str.slice(0, 3)}-${str.slice(3, 6)}-${str.slice(6)}`;
};

export const formatSSN = (ssn) => {
  const str = String(ssn || '');
  if (str.length !== 9) return 'N/A';
  return `${str.slice(0, 3)}-${str.slice(3, 5)}-${str.slice(5)}`;
};

export const isDate = (date) => {
  return new Date(date) !== "Invalid Date" && !isNaN(new Date(date));
};

export const getLabelType = (isOrder, isCapitalize) => {
  let label = isOrder ? 'order' : 'referral';

  if (isCapitalize) {
    label = label.charAt(0).toUpperCase() + label.slice(1);
  }

  return label;
};
